import { mapGetters, mapState } from 'vuex';

export default {
  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      activeRoomProducts: 'build/getProducts',
      allProducts: 'build/getAllProducts',
      allRoomsSelected: 'brand-color-selection/allRoomsSelected',
    }),
    buildProducts() {
      return this.allRoomsSelected ? this.allProducts : this.activeRoomProducts;
    },
    categoryAmount() {
      let amount = 0;

      for (const product of this.buildProducts) {
        if (this.category.id === product.categoryId) {
          amount += product.amount;
        }
      }

      return amount;
    },
    isCoverFrame() {
      return this.category.is_cover_frame === true;
    },
    requiredCoverFrameAmount() {
      let amount = 0;

      for (const product of this.buildProducts) {
        if (product.isCoverFrame) {
          continue;
        }

        amount += product.coverFrameAmount * product.amount;
      }

      return amount;
    },
    currentCoverFrameAmount() {
      let amount = 0;

      for (const product of this.buildProducts) {
        if (!product.isCoverFrame) {
          continue;
        }

        amount += product.coverFrameAmount * product.amount;
      }

      return amount;
    },
    hasCoverFrameWarning() {
      return this.currentCoverFrameAmount < this.requiredCoverFrameAmount;
    },
  },
};
